import React, { useMemo } from 'react';
import { ResponsiveContainer, ComposedChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export default function BundleYieldCurve({ data }) {
  const chartData = useMemo(() => {
    if (!data) return [];
    // Mock data if live analytical data isn't ready
    return [
      { name: '1 Service', yield: 100, efficiency: 95 },
      { name: '2 Services', yield: 185, efficiency: 88 },
      { name: '3 Services', yield: 260, efficiency: 82 },
      { name: '4 Services', yield: 320, efficiency: 75 },
      { name: '5+ Services', yield: 370, efficiency: 68 },
    ];
  }, [data]);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <ComposedChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis yAxisId="left" label={{ value: 'Yield ($)', angle: -90, position: 'insideLeft' }} />
          <YAxis yAxisId="right" orientation="right" label={{ value: 'Efficiency (%)', angle: 90, position: 'insideRight' }} />
          <Tooltip />
          <Legend />
          <Area yAxisId="left" type="monotone" dataKey="yield" fill="#0077B5" stroke="#0077B5" fillOpacity={0.1} name="Bundle Yield" />
          <Line yAxisId="right" type="step" dataKey="efficiency" stroke="#FF8042" strokeWidth={3} name="Margin Efficiency" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
